/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/9/3
 * Time: 下午3:24
 */

import { getToken } from '../apis/im'

export function getImInitParams (url, username) {
  try {
    return getToken(url, username)
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/services/websocket.js